<template>
  <div class="loader-container">
    <div class="loader-2" />
  </div>
</template>

<style scoped>
.loader-container {
  width: 30px;
  height: 10px;
  position: relative;
  top: 0;
  display: inline-block;
  text-align: center;
  vertical-align: top;
}
.loader-2 {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  position: relative;
  top: 10px;
  animation: loader-2 0.55s 0.35s ease alternate infinite;
  margin: -18px auto 0;
}

.loader-2:after,
.loader-2:before {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  animation: loader-2 0.55s ease alternate infinite;
}

.loader-2:before {
  left: -10px;
  animation-delay: 0.2s;
}

.loader-2:after {
  right: -10px;
  animation-delay: 0.5s;
}

@keyframes loader-2 {
  0% {
    box-shadow: 0 10px 0 -10px var(--color-primary-tints-600);
  }
  100% {
    box-shadow: 0 10px 0 var(--color-primary-tints-600);
  }
}
</style>
